import { Stack } from '@mui/material';
import React, { ReactNode } from 'react';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';
import Status500 from 'src/content/pages/Status/Status500';

interface AppErrorBoundaryProps {
  children: ReactNode;
}

export function AppErrorBoundary({ children }: AppErrorBoundaryProps) {
  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    // Handle the error here or log it to an error tracking service
    console.error(error, errorInfo);
  };

  const ErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
    console.log('error', error);
    const staticError = {
      message: 'Something went Wrong, please try again later'
    };
    return (
      <Stack
        justifyContent="center"
        sx={{ height: '100vh', width: '100%' }}
        alignItems="center"
      >
        <Status500 />;
      </Stack>
    );
  };

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={handleError}>
      {children}
    </ErrorBoundary>
  );
}
